import Link from "next/link";
import type { RelatedPost } from "@/types/IRelatedPost";
import { ArrowUpRightIcon } from "@/utils/images/Arrows";
import cls from "./RelatedPosts.module.css";

interface RelatedPostsProps {
  items: readonly RelatedPost[];
  title?: string;
  id?: string;
  className?: string;
}

export function RelatedPosts({ items, title = "Related posts", id = "related-posts", className = "" }: RelatedPostsProps) {
  if (items.length === 0) return null;

  return (
    <section className={`${cls.section} ${className}`} aria-labelledby={id}>
      <h2 className={cls.title} id={id}>{title}</h2>
      <ul className={cls.list}>
        {items.map(({ title: postTitle, href }) => (
          <li key={href}>
            <Link className={cls.link} href={href}>
              <span>{postTitle}</span>
              <ArrowUpRightIcon className={cls.icon} aria-hidden="true" focusable="false" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
